/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import "react-datepicker/dist/react-datepicker.css";

//Import PageHeader
import PageHeader from "../../components/PageHeader";

// Redux Store
import Inquirys from "../../components/Inquiry/Inquirys";

const AdminInquiry = () => {

  return (
    <>
      <PageHeader
        title={`1:1 문의 관리`}
      // buttons={headerButtons}
      />
      <Inquirys />
    </>
  );
};

export default AdminInquiry;
